import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';

/**
 * 列表
 * @param {number} page
 * @param {number} pageSize
 */
export async function mySalaryList(params) {
  return request(`${url.salaryApi}/salary/my/mySalaryList?${stringify(params)}`);
}

/**
 * 详情
 */
export async function detail(payload) {
  return request(`${url.salaryApi}/salary/my/mySalaryDetail?${stringify(payload)}`);
}
